import { gql } from '@apollo/client';
import { useLazyQuery } from '@hooks/apollo';

export const CATALOG_GQL = gql`
  query CATALOG_QUERY ($status: String!) {
    catalogs {
      cancelRequisitionReasons(status: $status) {
        id
        reason
      }
    }
  }
`;

export const useCancelReasonsQuery = (options) => useLazyQuery(CATALOG_GQL, {
  context: {
    clientName: 'public',
  },
  ...options,
});
